import { render, staticRenderFns } from "./solitaire.vue?vue&type=template&id=c1e252c8&scoped=true"
import script from "./solitaire.vue?vue&type=script&lang=js"
export * from "./solitaire.vue?vue&type=script&lang=js"
import style0 from "./solitaire.vue?vue&type=style&index=0&id=c1e252c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e252c8",
  null
  
)

export default component.exports